module.exports = __webpack_public_path__ + "img/sensitive.0412dfd6.png";